import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, OnChanges, Input } from '@angular/core';
import { LineHeightByComponent } from '@df/ui/common/line-height-by.component';
import { HrefComponent } from '@df/ui/common/href/href.component';

/**
 * Similar to swatch but presents checkbox icon instead
 */
@Component({
    selector: 'icon-label',
    standalone: true,
    imports: [HrefComponent, CommonModule, LineHeightByComponent],
    templateUrl: './icon-label.html',
    styleUrls: ['./icon-label.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconLabelComponent implements OnChanges {
    @Input()
    icon?: string;

    @Input()
    textClass = 'p2';

    @Input()
    offset = 2;

    @Input()
    iconLink?: string;

    @Input()
    @HostBinding('class._fullWidth')
    fullWidth?: boolean;

    @Input()
    @HostBinding('class._iconRight')
    iconRight?: boolean;

    @Input()
    iconSmall?: boolean;

    ngOnChanges(changes) {
        // normalize icon name in case we pass icon-something from icms
        if (changes.icon && this.icon) {
            this.icon = this.icon.replace(/^icon-/, '');
        }
    }
}
